(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["calistore-carrusel-compra"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cali-product-carousel-v2')) {
customElements.define('cali-product-carousel-v2', class extends HTMLElement {
  connectedCallback() {
    if(this.controller) return;
    this.controller = new AbortController();
    const signal = this.controller.signal;
    const listen = (el, type, fn, options={}) => el.addEventListener(type, fn, {...options,signal});
    const motion = () => matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth';
    const dialog = this.querySelector('dialog'), mount = this.querySelector('.cali-modal-body');
    const revealCart = async (result, root) => {
      // Finish the native dialog's close/focus restoration before opening Dawn's drawer.
      if (dialog.open) {
        await new Promise(resolve => {
          dialog.addEventListener('close', resolve, {once:true});
          dialog.close();
        });
      }
      try {
        const drawer = document.querySelector('cart-drawer');
        if (!drawer || typeof drawer.renderContents !== 'function') {
          window.location.assign(root+'cart');
          return;
        }
        const sections = result.sections;
        if (!sections?.['cart-drawer'] || !sections?.['cart-icon-bubble']) {
          window.location.assign(root+'cart');
          return;
        }
        drawer.setActiveElement?.(this.opener);
        drawer.classList.remove('is-empty');
        // Dawn refreshes its markup, binds the overlay and opens the drawer itself.
        drawer.renderContents(result);
      } catch {
        // The item is already added: show the cart without sending it again.
        window.location.assign(root+'cart');
      }
    };
    const panels = [...this.querySelectorAll('.cali-panel')];
    this.observers=[];
    panels.forEach(panel => {
      const track=panel.querySelector('.cali-track'), dots=panel.querySelector('.cali-dots');
      const cards=[...track.querySelectorAll('.cali-card')];
      const previous=panel.querySelector('[data-direction="-1"]'), next=panel.querySelector('[data-direction="1"]');
      let stops=[0], drag=null, suppressClick=false;
      const update = () => {
        const nearest=stops.reduce((best,x,i)=>Math.abs(x-track.scrollLeft)<Math.abs(stops[best]-track.scrollLeft)?i:best,0);
        [...dots.children].forEach((b,i)=>b.setAttribute('aria-current',String(i===nearest)));
        previous.disabled=track.scrollLeft<=2; next.disabled=track.scrollLeft>=track.scrollWidth-track.clientWidth-2;
      };
      const rebuild=()=>{
        if(!track.clientWidth) return;
        const width=cards[0]?.getBoundingClientRect().width || track.clientWidth;
        const gap=parseFloat(getComputedStyle(track).gap)||0;
        const perPage=Math.max(1,Math.round((track.clientWidth+gap)/(width+gap)));
        const max=Math.max(0,track.scrollWidth-track.clientWidth);
        const points=[0];
        for(let i=perPage;i<cards.length;i+=perPage) {const left=Math.min(i*(width+gap),max); if(left>points.at(-1)+2) points.push(left);}
        if(JSON.stringify(points)!==JSON.stringify(stops)||!dots.children.length){
          stops=points; dots.replaceChildren();
          points.forEach((x,i)=>{const button=document.createElement('button');button.type='button';button.setAttribute('aria-label','Ir al grupo '+(i+1));button.addEventListener('click',()=>track.scrollTo({left:x,behavior:motion()}));dots.append(button);});
        }
        dots.hidden=stops.length<=1;update();
      };
      panel.querySelectorAll('[data-direction]').forEach(button=>listen(button,'click',()=>{
        const direction=Number(button.dataset.direction);
        const target=direction>0 ? stops.find(x=>x>track.scrollLeft+3) ?? stops.at(-1) : [...stops].reverse().find(x=>x<track.scrollLeft-3) ?? 0;
        track.scrollTo({left:target,behavior:motion()});
      }));
      listen(track,'scroll',update,{passive:true});
      listen(track,'keydown',e=>{if(e.target!==track)return;if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();(e.key==='ArrowRight'?next:previous).click();}});
      listen(track,'dragstart',e=>e.preventDefault());
      listen(track,'pointerdown',e=>{if(e.pointerType!=='mouse'||e.button!==0||e.target.closest('button'))return;suppressClick=false;drag={x:e.clientX,left:track.scrollLeft,id:e.pointerId,moved:false};});
      listen(track,'pointermove',e=>{if(!drag)return;const dx=e.clientX-drag.x;if(Math.abs(dx)>6&&!drag.moved){drag.moved=true;track.setPointerCapture(e.pointerId);track.classList.add('is-dragging');}if(drag.moved){e.preventDefault();track.scrollLeft=drag.left-dx;}});
      const end=()=>{if(!drag)return;suppressClick=drag.moved;track.classList.remove('is-dragging');if(track.hasPointerCapture(drag.id))track.releasePointerCapture(drag.id);drag=null;};
      listen(track,'pointerup',end);listen(track,'pointercancel',end);listen(track,'pointerleave',()=>{if(drag&&!drag.moved)end();});
      listen(track,'click',e=>{if(suppressClick){e.preventDefault();e.stopPropagation();suppressClick=false;}},{capture:true});
      const ro=new ResizeObserver(rebuild);ro.observe(track);this.observers.push(ro);rebuild();
    });
    const tabs=[...this.querySelectorAll('[role="tab"]')];
    tabs.forEach((tab,i)=>{
      listen(tab,'click',()=>{tabs.forEach(t=>{const active=t===tab;t.setAttribute('aria-selected',String(active));t.tabIndex=active?0:-1;});panels.forEach(p=>p.hidden=p.id!==tab.getAttribute('aria-controls'));});
      listen(tab,'keydown',e=>{let next;if(e.key==='ArrowRight')next=(i+1)%tabs.length;if(e.key==='ArrowLeft')next=(i+tabs.length-1)%tabs.length;if(e.key==='Home')next=0;if(e.key==='End')next=tabs.length-1;if(next!==undefined){e.preventDefault();tabs[next].click();tabs[next].focus();}});
    });
    listen(this,'click',event=>{
      const opener=event.target.closest('[data-open]');if(!opener||opener.disabled)return;
      this.opener=opener;const body=document.createElement('div');body.append(opener.closest('article').querySelector('template').content.cloneNode(true));mount.replaceChildren(body);
      const gallery=body.querySelector('.cali-gallery'), photos=[...gallery.children], count=body.querySelector('[data-photo-count]');
      const galleryUpdate=()=>{const i=Math.round(gallery.scrollLeft/(gallery.clientWidth||1));count.textContent=(i+1)+' / '+photos.length;body.querySelector('[data-photo="-1"]').disabled=i===0;body.querySelector('[data-photo="1"]').disabled=i>=photos.length-1;};
      body.querySelectorAll('[data-photo]').forEach(b=>b.addEventListener('click',()=>gallery.scrollBy({left:Number(b.dataset.photo)*gallery.clientWidth,behavior:motion()})));
      gallery.addEventListener('scroll',galleryUpdate,{passive:true});
      body.querySelector('.cali-gallery-controls').hidden=photos.length<2;
      const form=body.querySelector('form'), select=form.querySelector('select'), submit=form.querySelector('[type="submit"]');
      const sizes=form.querySelector('.cali-sizes'), buttons=sizes.querySelector('.cali-size-buttons'), selected=sizes.querySelector('.cali-selected'), quantity=form.querySelector('[name="quantity"]');
      form.querySelector('.cali-select-label').hidden=true;sizes.hidden=false;
      const choices=[...select.options].filter(o=>o.value);
      const refresh=()=>{
        const option=select.selectedOptions[0];submit.disabled=!option?.value||option.disabled;
        submit.textContent=option?.value?'Agregar al carrito':'Elige tu talla';
        [...buttons.children].forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.value===select.value)));
        if(!option?.value)return;
        selected.textContent=option.textContent;
        body.querySelector('[data-price]').textContent=option.dataset.price;
        body.querySelector('[data-compare]').textContent=option.dataset.compare||'';
        const saving=body.querySelector('[data-saving]');saving.hidden=!option.dataset.discount;saving.textContent='−'+option.dataset.discount+'%';
        if(option.dataset.image){const url=new URL(option.dataset.image,location.href);const index=photos.findIndex(p=>p.tagName==='IMG'&&new URL(p.src,location.href).pathname===url.pathname);if(index>=0)gallery.scrollTo({left:index*gallery.clientWidth,behavior:motion()});}
      };
      choices.forEach(option=>{
        const b=document.createElement('button');b.type='button';b.className='cali-size';b.disabled=option.disabled;b.dataset.value=option.value;b.setAttribute('aria-label',option.textContent);b.title=option.textContent;
        // CaliStore stores COL / USA / EUR / CM / gender together in the variant title.
        const parts=option.textContent.split('|').map(s=>s.trim());
        const col=parts.find(s=>s.includes('COL')), cm=parts.find(s=>/CM/i.test(s)), gender=parts.find(s=>/^(Hombre|Mujer)$/i.test(s));
        const title=document.createElement('strong');title.textContent=col?col.replace(/\s*COL.*$/,''):option.textContent;b.append(title);
        if(cm||gender){const small=document.createElement('small');small.textContent=[cm,gender].filter(Boolean).join(' · ');b.append(small);}
        b.addEventListener('click',()=>{select.value=option.value;refresh();});buttons.append(b);
      });
      if(choices.length===1&&!choices[0].disabled)select.value=choices[0].value;
      refresh();
      const quantityUpdate=()=>form.querySelector('[data-quantity="-1"]').disabled=Number(quantity.value)<=1;
      form.querySelectorAll('[data-quantity]').forEach(b=>b.addEventListener('click',()=>{quantity.value=String(Math.max(1,(Number(quantity.value)||1)+Number(b.dataset.quantity)));quantityUpdate();}));
      quantity.addEventListener('input',quantityUpdate);quantityUpdate();
      form.addEventListener('submit',async event=>{
        event.preventDefault();if(submit.disabled||!form.reportValidity())return;
        const status=form.querySelector('[role="status"]');submit.disabled=true;submit.textContent='Agregando…';status.textContent='';
        const payload=new FormData(form);
        buttons.querySelectorAll('button').forEach(b=>b.disabled=true);
        let uncertain=false;
        try{
          const root=window.Shopify?.routes?.root||'/';
          payload.set('sections','cart-drawer,cart-icon-bubble');
          payload.set('sections_url',window.location.pathname);
          const response=await fetch(root+'cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:payload});
          const result=await response.json();
          if(!response.ok){status.textContent=result.description||'No se pudo agregar el producto. Revisa disponibilidad y cantidad.';return;}
          status.textContent='✓ '+payload.get('quantity')+' × '+body.querySelector('.cali-modal-title').textContent+' agregado al carrito.';
          form.querySelector('.cali-cart-link').hidden=false;
          this.dispatchEvent(new CustomEvent('calistore:cart-added',{bubbles:true,detail:result}));
          await revealCart(result,root);
        }catch{uncertain=true;status.textContent='No pudimos confirmar la respuesta. Revisa tu carrito antes de intentarlo de nuevo.';form.querySelector('.cali-cart-link').hidden=false;}
        finally{[...buttons.children].forEach((b,i)=>b.disabled=choices[i].disabled);refresh();if(uncertain){submit.disabled=true;submit.textContent='Revisa tu carrito';}}
      });
      dialog.showModal();dialog.scrollTop=0;galleryUpdate();
      this.previousOverflow=document.documentElement.style.overflow;document.documentElement.style.overflow='hidden';
    });
    listen(this.querySelector('.cali-close'),'click',()=>dialog.close());
    listen(dialog,'click',e=>{if(e.target===dialog){const b=dialog.getBoundingClientRect();if(e.clientX<b.left||e.clientX>b.right||e.clientY<b.top||e.clientY>b.bottom)dialog.close();}});
    listen(dialog,'close',()=>{document.documentElement.style.overflow=this.previousOverflow??'';this.opener?.focus();});
  }
  disconnectedCallback(){this.controller?.abort();this.controller=null;this.observers?.forEach(o=>o.disconnect());if(this.querySelector('dialog')?.open)document.documentElement.style.overflow=this.previousOverflow??'';}
});
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calistore-marcas"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cs-brand-carousel')) {
    customElements.define('cs-brand-carousel', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.setup());
      }
      setup() {
        const track = this.querySelector('.cs-brands__grid');
        const controls = this.querySelector('.cs-brands__controls');
        if (!track || !controls) return;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        const previous = controls.querySelector('[data-direction="-1"]');
        const next = controls.querySelector('[data-direction="1"]');
        const update = () => {
          const max = track.scrollWidth - track.clientWidth;
          controls.hidden = max <= 2;
          previous.disabled = track.scrollLeft <= 2;
          next.disabled = track.scrollLeft >= max - 2;
        };
        const move = (direction) => {
          const card = track.querySelector('.cs-brands__card');
          if (!card) return;
          const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap);
          const count = Math.max(1, Math.floor((track.clientWidth + 1) / step));
          track.scrollBy({ left: direction * step * count, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        };
        previous.addEventListener('click', () => move(-1), options);
        next.addEventListener('click', () => move(1), options);
        track.addEventListener('scroll', update, { ...options, passive: true });
        track.addEventListener('keydown', (event) => {
          if (event.target !== track) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            move(event.key === 'ArrowRight' ? 1 : -1);
          }
        }, options);
        this.addEventListener('shopify:block:select', (event) => {
          const card = event.target.closest('.cs-brands__card');
          if (card) track.scrollTo({ left: track.scrollLeft + card.getBoundingClientRect().left - track.getBoundingClientRect().left, behavior: 'auto' });
        }, options);
        this.observer = new ResizeObserver(update);
        this.observer.observe(track);
        update();
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.events?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
